import React, { Component } from "react";
// import classes from './LegislationTable.module.css'
import AllStates from "../AllStates";
import ReactTable from "react-table";
import { withRouter } from "react-router-dom";
class LegislationTable extends Component {
  render() {
    let shownLegislationItems;
    shownLegislationItems = this.props.legislationItems;
    const columns = [
      {
        Header: "ID",
        accessor: "legislative_id",
        show: false
      },
      {
        Header: "State",
        accessor: "state_id",
        Cell: props => AllStates[props.value - 1].state_name,
        maxWidth: 200
      },
      { Header: "Bill ID", accessor: "bill_id", maxWidth: 200 },
      {
        Header: "P3 Transportation Sector Authorized",
        accessor: "p3_transportation_sector_authorized"
      },
      {
        Header: " P3 Enactment Year",
        accessor: "p3_enactment_year",
        maxWidth: 200
      },
      {
        Header: "Project Types Authorized",
        accessor: "project_types_authorized"
      }
    ];
    columns.forEach(h => (h.headerStyle = { fontWeight: "bold" }));
    let filterCaseInsensitive = (filter, row) => {
      const id = filter.pivotId || filter.id;
      if (filter.id === "state_id") {
        let res = [
          ...new Set(
            row.state_id
              .toString()
              .split(" ")
              .map(
                v =>
                  v &&
                  AllStates[Number.parseInt(v) - 1] &&
                  AllStates[Number.parseInt(v) - 1].state_name.toLowerCase()
              )
          )
        ];
        return res.some(x => x && x.startsWith(filter.value.toLowerCase()));
      }
      return row[id]
        ? String(row[id])
            .toLowerCase()
            .startsWith(filter.value.toLowerCase())
        : false;
    };

    return (
      <ReactTable
        className="-highlight -striped"
        data={shownLegislationItems}
        columns={columns}
        page={this.props.page}
        onPageChange={this.props.changePage}
        defaultFilterMethod={filterCaseInsensitive}
        filterable
        onFilteredChange={filters => {
          console.log(filters);
          localStorage.setItem("legislation_filters", JSON.stringify(filters));
        }}
        defaultFiltered={
          JSON.parse(localStorage.getItem("legislation_filters")) || []
        }
        getTdProps={(state, rowInfo, column, instance) => {
          return {
            onClick: (e, handleOriginal) => {
              this.props.history.push("/legislation/detail");
              this.props.clicked(rowInfo.row.legislative_id);
            }
          };
        }}
      />
    );
  }
}

export default withRouter(LegislationTable);
